<section class="preview">
  <div class="sistema-mockup">

    <!-- Sidebar -->
    <div class="mockup-sidebar">
      <div class="sidebar-icons">
        <div class="sidebar-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
        </div>
        <div class="sidebar-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
        </div>
        <div class="sidebar-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
        </div>
        <div class="sidebar-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="5" rx="1"/><rect x="2" y="11" width="20" height="5" rx="1"/><rect x="2" y="18" width="20" height="3" rx="1"/></svg>
        </div>
        <div class="sidebar-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
        </div>
        <div class="sidebar-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
        </div>
        <div class="sidebar-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
        </div>
        <div class="sidebar-icon active">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14"/></svg>
        </div>
        <div class="sidebar-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="21" y2="12"/><path d="M3 6h9M3 18h9"/><path d="M16 4l5 5-5 5"/></svg>
        </div>
        <div class="sidebar-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
        </div>
        <div class="sidebar-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
        </div>
      </div>
      <div class="sidebar-logo">
        <div class="sidebar-logo-icon"><img src="assets/img/logo_azul.jpg" style="width: 30px; border-radius: 8px;" alt="Logo"></div>
      </div>
      <div class="sidebar-version">v.8.12.0</div>
    </div>

    <!-- Main content -->
    <div class="mockup-main">

      <!-- Top bar -->
      <div class="mockup-topbar">
        <div class="topbar-help">
          <span class="help-icon">?</span>
          <span>Precisa de ajuda?</span>
        </div>
        <div class="topbar-company">
          <span class="company-label">Empresa:</span>
          <div class="company-input">Mister Contador</div>
          <div class="company-cnpj">00017714000177</div>
        </div>
      </div>

      <!-- Page content -->
      <div class="mockup-content">
        <h3 class="mockup-page-title">Extrato Bancário</h3>

        <!-- Filters -->
        <div class="mockup-filters">
          <div class="filter-search">
            <span>Pesquisar</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          </div>
          <div class="filter-date">
            <span>Maio de 2026</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          </div>
          <div class="filter-select">
            <span>Todos</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="filter-bank">
            <span class="bank-pill">inter</span>
            <span>0001/5090001</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="filter-actions">
            <div class="integracao-wrapper">

              <!-- Guia passo 1: aparece só após clicar em Começar -->
              <div class="guia-passo" *ngIf="guiaAtivo && lancamentos.length === 0 && !integracaoAberta">
                <div class="guia-seta">↑</div>
                <span>Clique aqui</span>
              </div>

              <button
                class="btn-integracao"
                [class.btn-destaque]="guiaAtivo && lancamentos.length === 0"
                (click)="integracaoAberta = !integracaoAberta"
              >
                Integração
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
              </button>

              <div class="integracao-dropdown" *ngIf="integracaoAberta">
                <span class="integracao-label">Selecione o mês e ano:</span>
                <div class="integracao-input">
                  <span>março de 2026</span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                </div>
                <!-- Guia passo 2: seta no processar -->
                <div class="guia-processar" *ngIf="guiaAtivo && lancamentos.length === 0">
                  <span>Agora clique aqui</span>
                  <div class="guia-seta-baixo">↓</div>
                </div>
                <button class="integracao-processar" (click)="processarIntegracao()">Processar</button>
              </div>
            </div>
            <button class="btn-carregar">
              Carregar
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></svg>
            </button>
          </div>
        </div>

        <!-- Tab -->
        <div class="mockup-tabs">
          <div class="mockup-tab active">
            Lançamentos
            <span class="tab-badge">{{ lancamentos.length > 0 ? '100' : '0' }}</span>
          </div>
        </div>

        <!-- Table -->
        <div class="mockup-table" [class.has-data]="lancamentos.length > 0">

          <ng-container *ngIf="lancamentos.length === 0">
            <div class="table-header">
              <div class="th">Dt Pagamento <span class="sort-icon">↑</span></div>
              <div class="th">Saída</div>
              <div class="th">Entrada</div>
              <div class="th">Documento</div>
              <div class="th">Histórico Bancário</div>
              <div class="th">Informação</div>
              <div class="th th-check">
                <input type="checkbox" disabled />
                Exclusão múltipla
              </div>
            </div>
            <div class="table-empty">
              <ng-container *ngIf="!guiaAtivo">
                <span>Nenhum Extrato encontrado</span>
              </ng-container>
              <ng-container *ngIf="guiaAtivo">
                <span class="table-empty-hint">Clique em <strong>Integração</strong> e depois em <strong>Processar</strong></span>
              </ng-container>
            </div>
          </ng-container>

          <ng-container *ngIf="lancamentos.length > 0">
            <div class="table-header">
              <div class="th">Dt Pagamento <span class="sort-icon">↑</span></div>
              <div class="th">Saída</div>
              <div class="th">Entrada</div>
              <div class="th">Documento</div>
              <div class="th">Histórico Bancário</div>
              <div class="th">Informação</div>
              <div class="th th-check">
                <input type="checkbox" disabled />
                Exclusão múltipla
              </div>
            </div>
            <div class="extrato-body">
              <div
                *ngFor="let row of lancamentos"
                class="extrato-row"
                [class.extrato-soma]="row.soma"
              >
                <div class="td td-data">{{ row.data }}</div>
                <div class="td td-saida">{{ row.saida }}</div>
                <div class="td td-entrada">{{ row.entrada }}</div>
                <div class="td td-doc">
                  <span *ngIf="!row.soma" class="icon-doc">📄</span>
                  <span *ngIf="!row.soma" class="icon-check">✓</span>
                </div>
                <div class="td td-hist">{{ row.historico }}</div>
                <div class="td"></div>
                <div class="td td-trash">
                  <span *ngIf="!row.soma" class="icon-trash">🗑</span>
                </div>
              </div>
            </div>

            <div class="extrato-paginacao">
              <span class="paginacao-info">Mostrando 1 - 100 de 100 resultados.</span>
              <div class="paginacao-controles">
                <button class="pag-btn">&laquo;&laquo;</button>
                <button class="pag-btn">&laquo;</button>
                <button class="pag-btn ativo">1</button>
                <button class="pag-btn">&raquo;</button>
                <button class="pag-btn">&raquo;&raquo;</button>
              </div>
            </div>
          </ng-container>

        </div>

        <!-- Central Mister Button -->
        <div class="central-mister-btn">
          <div class="sidebar-logo-icon"><img src="assets/img/logo_azul.jpg" style="width: 30px; border-radius: 8px;" alt="Logo"></div>
          <span>Central Mister</span>
        </div>
      </div>
    </div>
  </div>
</section>
